import { ChangeDetectorRef, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CartItemContextSource } from '@spartacus/cart/base/components';
import { ActiveCartFacade, CartItemContext, OrderEntry } from '@spartacus/cart/base/root';
import { debounceTime, Subject } from 'rxjs';
import { CartPageModalComponent } from '../cart-page-modal/cart-page-modal.component';
import { KnBrCommonService } from 'src/app/services/kn-br-common.service';
import { cwtOrderEntry } from 'src/app/models/kn-br-products.model';
import { RoutingService } from '@spartacus/core';
import { formatTwoDecimals } from 'src/constants/commonUtils';
import { NgClass } from '@angular/common';
import { MediaComponent } from '@spartacus/storefront';
import { CwtCartItemCounterComponent } from '../cwt-cart-item-counter/cwt-cart-item-counter.component';

@Component({
    selector: 'cwt-cart-item-row',
    templateUrl: './cwt-cart-item-row.component.html',
    styleUrls: ['./cwt-cart-item-row.component.scss'],
    providers: [
        CartItemContextSource,
        { provide: CartItemContext, useExisting: CartItemContextSource },
    ],
    imports: [NgClass, MediaComponent, CwtCartItemCounterComponent]
})
export class CwtCartItemRowComponent implements OnChanges {
  quantityUpdateSubject = new Subject<number>();
  quantityControl: UntypedFormControl;
  addToCartForm = new UntypedFormGroup({
    quantity: new UntypedFormControl(1, { updateOn: 'blur' }),
  });
  @Input() item: cwtOrderEntry;
  modalRef: any;

  constructor(private activeCartService: ActiveCartFacade, protected cdr: ChangeDetectorRef, private modalService: NgbModal,
    private knBrCommonService: KnBrCommonService,protected routingService: RoutingService,
  ) { }
  ngOnInit() {
    this.quantityUpdateSubject
      .pipe(debounceTime(500))
      .subscribe((latestCount) => {
        if (this.item?.entryNumber !== undefined) {
          this.activeCartService.updateEntry(this.item.entryNumber, latestCount);
          // this.isSpinnerActive.emit(false)
        }
      });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['item'] && this.item) {
      this.addToCartForm.get('quantity')?.setValue(this.item?.quantity);
       this.knBrCommonService.setInlineSpinner('');
    }
  }

  removeItem() {
    this.modalRef = this.modalService.open(CartPageModalComponent, {
      centered: true,
        size: 'lg',
    });
    this.modalRef.componentInstance.item = this.item;
  }

  getLatestCount(event: number): void {
    this.knBrCommonService.setInlineSpinner('cart-loader');
    // this.isSpinnerActive.emit(true)
    this.quantityUpdateSubject.next(event);
    this.knBrCommonService.isCartLoading.set(true);
  }

  goToDetail(event) {
    // avoid PDP routing on add to cart seciton
    if (event.target.closest('.product-actions')) {
      return;
    }

    this.knBrCommonService.setSpinner(true);
    this.routingService.go({ cxRoute: "product", params: this.item.product });
  }

  formatPrice(priceValue) {
    return formatTwoDecimals(priceValue);
  }
}
